$(document).ready(function () {
    $('.addTopicTutor-btn').on('click', function () {
        $('#addTutorAccess').modal('show');
    });

    $('.removeTopicTutor-btn').on('click', function () {
        $('#removeTutorAccess').modal('show');
        var tutor = $(this).parents('.topicTutor-row').data('tutor');
        $('input[type="hidden"][name="topictutor_id"]').val(tutor.id);
        $('input[type="hidden"][name="topic_id"]').val(tutor.topic_id);
        $('h4 span, .tutorName').empty().append(tutor.title + ' ' + tutor.firstname + ' ' + tutor.lastname);
    });
});
